import type { FaireProductEntity } from "../../entity_types/product";

export const p_ehw2z3t6ex: FaireProductEntity = {
  token: "p_ehw2z3t6ex",
  type: "product",
  name: "Blue Moon Face Serum",
  brandToken: "b_byf8uyy27h",
  brandName: "My Neighbor’s",
  imageUrl:
    "https://cdn.faire.com/fastly/726fd4f7757d3826a0407c2b70713fcd43146885444f0eaacef9a358d0513e3f.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/0a5b71fea34343c44b84410c6b2d5bef9abccfebadb8e260cea82b7880abd225.jpeg",
    "https://cdn.faire.com/fastly/5ae05b0c0e7926c86a25f2e9859694dbfc1bcb708e53768204d45c2b68d88c82.jpeg",
    "https://cdn.faire.com/fastly/2ac429c52c76d553e38e78ee14641cb2ed10e9de163310cd193a74ce1a8e8d8d.jpeg",
    "https://cdn.faire.com/fastly/9f0214e1b266bb9c36f96d9aeb6b235c04594a4b094cb11a03b7259583205762.jpeg",
    "https://cdn.faire.com/fastly/d71bc413558b111a3f10f2de19c375e36bff7d957ec04ebb508dc85af058383b.jpeg",
    "https://cdn.faire.com/fastly/9247e0103dad233010583a70876aea1d44e09c3ce3494bca5efff671bf41c5d8.jpeg",
    "https://cdn.faire.com/fastly/1a4e8b9312501487d68f770b78860375d75dfba8aa01fb24a6a68d5fa815690c.jpeg",
  ],
  priceDollars: 39.5,
  description:
    "Meet the Blue Moon Face Serum — the perfect companion to our best-selling Blue Moon Tallow Balm.\n\nCrafted with a potent blend of organic, non-GMO oils—jojoba, rosehip, seabuckthorn, carrot seed, vitamin E, and blue tansy—this lightweight serum deeply hydrates, calms inflammation, and restores balance to stressed or sensitive skin.\n\nLayer it under your tallow balm for dewy, radiant skin and next-level nourishment.\n",
  tags: [],
  msrpDollars: 79,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-04-19T21:22:43.382Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
